import { guardClient } from '../_axios'

/**
 * 会社情報の削除
 * [delete]/company/{id}
 */
export type EraseRequestType = { id: number; version: string }
export const deleteCompany = async (request: EraseRequestType) => {
  const path = '/company'
  const { id, version } = request
  const response = await guardClient.delete(path + '/' + id, {
    data: { version }
  })
  return response.data
}
